var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"zList",class:['z-list', `elevation-${ _vm.elevation }`],style:({
    height: _vm.computedHeight,
    maxHeight: _vm.computedMaxHeight,
    minHeight: _vm.computedMinHeight,
    width: _vm.computedWidth
  }),on:{"scroll":_vm.onScroll}},[_c('div',{staticClass:"z-list-header"},[_vm._t("header")],2),_c('ul',{staticClass:"z-list-items"},[_vm._l((_vm.dataSource),function(item,index){return [_c('li',{key:`list_item_${ index }`,class:['z-list-item', `z-list-item${ index }`, _vm.activedIndex === index ? 'actived' : ''],on:{"click":function($event){return _vm.onSelectItem(index)}}},[_vm._t("default",null,{"item":item,"index":index})],2)]})],2),_c('div',{staticClass:"z-list-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }